import apiFetch from "../apiFetch";

/**
 * Reports progress toward the user's active daily task.
 * Reads dt_params from sessionStorage (set by dailyTasksPage when launching a game).
 * Clears sessionStorage after reporting so the next session doesn't double-count.
 *
 * @param {number} count - Words correct / answers this session (default 1 for session-based games)
 */
export async function reportDailyTaskCompletion(count = 1) {
  const raw = sessionStorage.getItem("dt_params");
  if (!raw) return null;

  let params;
  try {
    params = JSON.parse(raw);
  } catch {
    sessionStorage.removeItem("dt_params");
    return null;
  }

  sessionStorage.removeItem("dt_params");

  if (!params?.taskId) return null;

  try {
    const res = await apiFetch(`/api/daily-tasks/${params.taskId}/complete`, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify({ count }),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

export function getActiveDailyTaskParams() {
  const raw = sessionStorage.getItem("dt_params");
  if (!raw) return null;
  try { return JSON.parse(raw); } catch { return null; }
}
